import React, { useEffect } from "react";
import { useStylesheet } from "../lib/useStylesheet.js";

export function AuthFrame({ title, subtitle, children }) {
  useStylesheet("/styles/client_site.css");

  useEffect(() => {
    document.title = `${title} · STEMEIT`;
  }, [title]);

  return (
    <main id="login-screen">
      <section className="login-box auth-card react-auth-card slide">
        <header className="login-header">
          <div className="login-icon">
            <img className="react-auth-logo" src="/images/logo-color.png" alt="STEMEIT" />
          </div>
          <div className="react-auth-brand-copy">
            <strong>STEMEIT</strong>
            <span>Recruitment Portal</span>
          </div>
        </header>
        <h1 className="react-auth-heading">{title}</h1>
        {subtitle && <p className="react-auth-description">{subtitle}</p>}
        {children}
      </section>
    </main>
  );
}
